import styled from "styled-components";
import { fonts } from "styles/fonts";

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  padding: 8px;
`;

export const MessageItem = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
  padding-bottom: 8px;
  border-bottom: 1px dotted #ffffff30;

  &:last-child {
    border-bottom: none;
  }
`;

export const MessageLabel = styled.span`
  font-size: 12px;
  font-family: ${fonts.GilroyBold};
  color: white;
`;

export const MessageValue = styled.p`
  font-size: 12px;
  font-family: ${fonts.OpenSans};
  color: white;
`;
export const MessageValueSmall = styled.p`
  font-size: 10px;
  font-family: ${fonts.OpenSans};
  color: white;
`;
